import React, { useEffect } from 'react';
import Preloader from '../../components/Preloader';
import {
    BannerSection,
    AboutSection,
    ExpertiseSection,
    ResumeSection,
    My3eSection,
} from './';
import useWow from '../../hooks/useWow';

/**
 * Home Page Component
 *
 * Renders the landing page of the application with all primary sections.
 * Applies page-specific CSS class and initializes WOW animations.
 *
 * @returns {JSX.Element} Home page layout
 */
const Home = () => {
    const { initWow } = useWow();

    useEffect(() => {
        // Add body class specific to Home page for scoped styling
        document.body.classList.add('home');

        // Initialize WOW.js animations
        initWow();

        // Cleanup: remove class when component unmounts
        return () => {
            document.body.classList.remove('home');
        };
        // `initWow` is stable and doesn't need to be a dependency
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Preloader />
            <BannerSection />
            <AboutSection />
            <ExpertiseSection />
            <ResumeSection />
            <My3eSection />
        </>
    );
};

export default Home;
